import React from 'react';
import { PropTypes } from 'prop-types';
import styled from '@emotion/styled'

const Button = styled('button')`
  padding: 0.25rem 1rem;
  margin-left: 1rem;
  font-size: 0.85rem;
  border: 1px solid;
  color: ${(props) => (props.isAuthenticated ? '#333333' : '#ffffff')};
  background-color: ${(props) =>
    props.isAuthenticated ? 'transparent' : '#2b6dad'};
  border-color: ${(props) => (props.isAuthenticated ? '#cacaca' : '#2b6dad')};
`;

function AppButton({ isAuthenticated, label, action }) {
  return (
    <Button 
    	className="btn" 
    	isAuthenticated={isAuthenticated}
    	onClick={action}
    >
      {label}
    </Button>
  );
}

AppButton.propTypes = {
  isAuthenticated: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  action: PropTypes.func.isRequired,
};

export default AppButton;
